/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import { Button, Tooltip, Icon, Row, Col, Collapse } from "antd";
import { ChartCard } from "ant-design-pro/lib/Charts";
import Trend from 'ant-design-pro/lib/Trend';
import numeral from "numeral";
import Nis from "../../components/Nis";
import LangContext from "../../contextProvider/LangContext";
import "../Dashboard.css";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import moment from "moment";
import TableIDs from "../../data/TableIDs";

class ShortSummarySection extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isProductivityExtended: false,
            isAverageLinesExtended: false,
            isAverageSaleExtended: false,
            isSalesExtended: false,

            costValue: null,
            noTaxValue: null,

            apiData: {
                productivity: {
                    today: { totalSales: 0, totalWorkingHours: 0, productivity: 0 },
                    weekAgo: { totalSales: 0, totalWorkingHours: 0, productivity: 0, diff: 0 },
                    monthAgo: { totalSales: 0, totalWorkingHours: 0, productivity: 0, diff: 0 },
                    sixMonthsAgo: { totalSales: 0, totalWorkingHours: 0, productivity: 0, diff: 0 },
                    twelveMonthsAgo: { totalSales: 0, totalWorkingHours: 0, productivity: 0, diff: 0 },
                },
                lines: {
                    today: { documentCount: 0, lineCount: 0, avg: 0 },
                    weekAgo: { documentCount: 0, lineCount: 0, avg: 0, diff: 0 },
                    monthAgo: { documentCount: 0, lineCount: 0, avg: 0, diff: 0 },
                    sixMonthsAgo: { documentCount: 0, lineCount: 0, avg: 0, diff: 0 },
                    twelveMonthsAgo: { documentCount: 0, lineCount: 0, avg: 0, diff: 0 },
                },
                documents: {
                    today: { count: 0, max: 0, sum: 0, avg: 0 },
                    weekAgo: { count: 0, max: 0, sum: 0, avg: 0, diff: 0, diffAvg: 0 },
                    monthAgo: { count: 0, max: 0, sum: 0, avg: 0, diff: 0, diffAvg: 0 },
                    sixMonthsAgo: { count: 0, max: 0, sum: 0, avg: 0, diff: 0, diffAvg: 0 },
                    twelveMonthsAgo: { count: 0, max: 0, sum: 0, avg: 0, diff: 0, diffAvg: 0 },
                }
            }
        }

        this.profits_id = "PROFITS_DATA";
        this.catering_id = "CATERING_TICKETS_DATA";

        if (props.data[this.profits_id] === undefined) props.data[this.profits_id] = { ...props.data.genericData }
        if (props.data[this.catering_id] === undefined) props.data[this.catering_id] = { ...props.data.genericData }

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }


    componentDidUpdate(p) {
        const { dashboardPos, dashboardDate, dashboardHour, firstLoading } = this.props

        if (p.firstLoading !== firstLoading) {
            // if (p.dashboardDate !== dashboardDate || p.dashboardPos !== dashboardPos || p.dashboardHour !== dashboardHour) {
            const endDay = d => moment(d).add(1, "day").add(-1, "second").format("YYYY-MM-DD HH:mm:ss")
            const _today = moment(dashboardDate).format("YYYY-MM-DD") + " " + dashboardHour
            const _weekAgo = moment(_today).add(-7, "day").format("YYYY-MM-DD HH:mm:ss")
            const _monthAgo = moment(_today).add(-1, "month").format("YYYY-MM-DD HH:mm:ss")
            const _sixMonthsAgo = moment(_today).add(-6, "month").format("YYYY-MM-DD HH:mm:ss")
            const _twelveMonthsAgo = moment(_today).add(-12, "month").format("YYYY-MM-DD HH:mm:ss")

            let dataSend = 'posList\ffromDatetime\ftoDatetime\r' + dashboardPos + "\f" + _today + "\f" + endDay(_today)

            this.sendAPI("get_dashboard_profits", dataSend, ob => {
                let d = ob.data ? ob.data.split("\f") : ['0', '0']
                this.setState({ costValue: parseFloat(d[0]), noTaxValue: parseFloat(d[1]) })
            });


            dataSend += "\r"
                + dashboardPos + "\f" + _weekAgo + "\f" + endDay(_weekAgo) + "\r"
                + dashboardPos + "\f" + _monthAgo + "\f" + endDay(_monthAgo) + "\r"
                + dashboardPos + "\f" + _sixMonthsAgo + "\f" + endDay(_sixMonthsAgo) + "\r"
                + dashboardPos + "\f" + _twelveMonthsAgo + "\f" + endDay(_twelveMonthsAgo)

            this.sendAPI("dashboard_get_short_sum", dataSend, ob => {
                let apiData = { ...this.state.apiData }
                if (ob.data) {

                    ob.data.split("\r").forEach((x, i) => {
                        let keysList = ["today", "weekAgo", "monthAgo", "sixMonthsAgo", "twelveMonthsAgo"]
                        let keyIndex = keysList[i]
                        const numFormat = y => parseFloat(y) ? Number(parseFloat(y).toFixed(6)) : 0

                        const [count, countItems, sum, max, totalWorkingHours] = x.split("\f").map(numFormat)

                        const avg = sum && count ? numFormat(sum / count) : 0
                        const avgItems = countItems && count ? numFormat(countItems / count) : 0

                        const productivity = sum && totalWorkingHours ? numFormat(sum / totalWorkingHours) : 0

                        const diff = apiData.documents.today.sum && sum ? numFormat(apiData.documents.today.sum / sum - 1) : 0
                        const diffItem = apiData.lines.today.lineCount && countItems ? numFormat(apiData.lines.today.lineCount / countItems - 1) : 0
                        const diffAvg = apiData.documents.today.avg && avg ? numFormat(apiData.documents.today.avg / avg - 1) : 0
                        const diffProductivity = apiData.productivity.today.productivity && productivity ? numFormat(apiData.productivity.today.productivity / productivity - 1) : 0

                        apiData.documents[keyIndex] = { count, max, sum, avg, diff, diffAvg }
                        apiData.lines[keyIndex] = { documentCount: count, lineCount: countItems, avg: avgItems, diff: diffItem }
                        apiData.productivity[keyIndex] = { totalSales: sum, totalWorkingHours, productivity, diff: diffProductivity }

                    })
                    this.setState({ apiData })
                }
            })
        }
    }

    sendAPI = (script, data, sCallback) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCallback, (e) => { console.error(e) });
    }


    createTrend = (percent) => {
        return (<Trend flag={percent > 0 ? "up" : "down"} reverseColor={true} style={{ marginLeft: "4px", fontWeight: "bold" }}>
            {numeral(percent * 100).format('0,0')}%
        </Trend>)
    }

    getDetails = (obj, avg, isProfitContent) => {
        if (isProfitContent) {
            const { noTaxValue, costValue } = this.state
            const profitValue = noTaxValue - costValue;

            return (<div className={"chart-card-details"}>
                <div>{this.createTrend(profitValue / noTaxValue)}{this.getText(19847)}</div>
                <div>{this.createTrend(profitValue / costValue)}{this.getText(19848)}</div>
            </div>)
        } else {
            return (<div className={"chart-card-details"}>
                <div>{this.createTrend(avg ? obj.weekAgo.diffAvg : obj.weekAgo.diff)}{this.getText(10123)}</div>
                <div>{this.createTrend(avg ? obj.monthAgo.diffAvg : obj.monthAgo.diff)}{this.getText(10124)}</div>
                <div>{this.createTrend(avg ? obj.sixMonthsAgo.diffAvg : obj.sixMonthsAgo.diff)}{this.getText(10125)}</div>
                <div>{this.createTrend(avg ? obj.twelveMonthsAgo.diffAvg : obj.twelveMonthsAgo.diff)}{this.getText(10126)}</div>
            </div>)
        }
    }

    getChartCard = (title, tooltip, total, data, stateName, avg, width) => {
        let isExtended = this.state[stateName];
        let isCountContent = stateName === 'isAverageLinesExtended'
        let isProfitContent = stateName === 'isProfitExtended'
        let footer = (<Button htmlType={"button"} onClick={() => { this.setState({ [stateName]: !isExtended }) }}>{this.getText(isExtended ? 10121 : 10122)}</Button>);

        return (<div style={{ marginBottom: "24px", display: "inline-block", width, padding: 10 }}>
            <ChartCard
                bordered={false} title={title} action={(<Tooltip title={tooltip}><Icon type="info-circle-o" /></Tooltip>)}
                loading={this.props.isLoading} total={() => this.getSum(total, isCountContent ? 1 : 0)} footer={footer} contentHeight={46}
            >{isExtended ? this.getDetails(data, avg, isProfitContent) : null}</ChartCard>
        </div>)
    }

    getSum = (sum, toFixed) => {
        const formatter = new Intl.NumberFormat('he-IL', {
            style: 'decimal',
            minimumFractionDigits: toFixed,
            maximumFractionDigits: toFixed,
        });

        return formatter.format((parseFloat(sum) ? parseFloat(sum) : 0) / (this.props.currencyValue ?? 1)) + " " + this.props.currencySymbol
    }

    getMobilePanel = (title, tooltip, total, data, stateName, avg) => {
        let isCountContent = stateName === 'isAverageLinesExtended'
        let isProfitContent = stateName === 'isProfitExtended'

        return (<Collapse.Panel
            header={(<span>
                <h3>{title}</h3>
                <h3>{this.getSum(total, isCountContent ? 1 : 0)}</h3>
            </span>)}
        >
            <div style={{ marginBottom: 5 }}>{tooltip}</div>
            <div>{this.getDetails(data, avg, isProfitContent)}</div>
        </Collapse.Panel>)
    }

    render() {
        let gt = this.getText;
        const { productivity, lines, documents } = this.state.apiData;


        let productivityTooltip = (<div>{gt(10118)}. {gt(10119)} <b>{productivity.today.totalWorkingHours?.toFixed(2)}</b> {gt(10120)}</div>);
        let linesTooltip = (<div><b>{lines.today.lineCount}</b> {gt(10128)}</div>);
        let documentsAvgTooltip = (<div>{gt(10130)}: <b>{this.getSum(documents.today.max, 2)}</b></div>);
        let documentsTooltip = (<div>{gt(10119)}: <b>{documents.today.count}</b> {gt(10132)}</div>);
        let profitTooltip = (<div>{gt(19845)}: <b>{this.getSum(this.state.costValue, 2)}</b><br /> {gt(19846)}: <b>{this.getSum(this.state.noTaxValue, 2)}</b></div>);
        let profitValue = (this.state.noTaxValue - this.state.costValue)?.toFixed(0);

        let cateringSum = 0;
        if (this.props.data[this.catering_id] && this.props.viewPaysType != '1') {
            this.props.data[this.catering_id].data.forEach(((x) => {
                let y = x.split('\f');
                cateringSum += parseFloat(y[1]);
            }))
        }

        let hideProfit = this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset?.find(f => f.code === '548') ? true : false

        let dataRes = [
            [gt(10131), documentsTooltip, documents.today.sum + parseInt(cateringSum), documents, 'isSalesExtended'],
            hideProfit ? null : [gt(19844), profitTooltip, profitValue, documents, 'isProfitExtended', true],
            [gt(10129), documentsAvgTooltip, documents.today.avg, documents, 'isAverageSaleExtended', true],
            [gt(10127), linesTooltip, lines.today.avg, lines, 'isAverageLinesExtended'],
            [gt(10117), productivityTooltip, productivity.today.productivity, productivity, 'isProductivityExtended'],
        ].filter(x => x);

        let mobile = window.innerWidth <= 600;


        return mobile ?
            (<Collapse style={{ marginBottom: 20 }}>
                {dataRes.map(x => this.getMobilePanel(x[0], x[1], x[2], x[3], x[4], x[5]))}
            </Collapse>)
            :
            (<div style={{ marginBottom: "0" }}>
                {dataRes.map(x => this.getChartCard(x[0], x[1], x[2], x[3], x[4], x[5], hideProfit ? "25%" : "20%"))}
            </div>);

    }
}
export default ShortSummarySection;
